import { createFileRoute, redirect } from '@tanstack/react-router'

import { validateDashboardSearch } from '#/pages/home/lib/dashboard-search'

export const Route = createFileRoute('/_shell/home')({
  validateSearch: validateDashboardSearch,
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/', search: { ...search, view: 'home' as const } })
  },
})
